import Switch from './switch'
export { ISwitchProps } from './switch'
export default Switch
